import { answerIndex } from "@/data/questionnaire";

// Règles d'orientation vers un professionnel de santé.
//
// Ces règles ne produisent JAMAIS de diagnostic et ne nomment aucune pathologie.
// Elles repèrent uniquement des réponses qui sortent du champ cosmétique et pour
// lesquelles l'avis d'un médecin est préférable avant d'engager un protocole.
// Les réponses sont comparées par indice d'option, donc indépendamment de la langue.
const RULES = [
  // Zones dégarnies apparues rapidement.
  { id: "patches", test: (i) => i.patches >= 1 },
  // Douleur nette ou lésions du cuir chevelu.
  { id: "scalp_pain", test: (i) => i.scalp_pain >= 2 },
  // Chute forte et d'installation très récente.
  { id: "sudden_shedding", test: (i) => i.shedding === 3 && i.shedding_onset === 0 },
  // Chute marquée qui continue de s'aggraver.
  { id: "worsening_shedding", test: (i) => i.shedding >= 2 && i.shedding_trend === 2 },
  // Coiffures sous tension ayant déjà dégarni des zones.
  { id: "traction", test: (i) => i.styling_tension === 3 },
];

// Renvoie la liste des identifiants de règles déclenchées (vide si aucune).
export const triageFlags = (questions, answers) => {
  const indices = {};
  ["patches", "scalp_pain", "shedding", "shedding_onset", "shedding_trend", "styling_tension"].forEach((id) => {
    indices[id] = answerIndex(questions, answers, id);
  });
  return RULES.filter((rule) => rule.test(indices)).map((rule) => rule.id);
};

export const TRIAGE_COPY = {
  fr: {
    title: "Certaines de vos réponses méritent l'avis d'un professionnel de santé",
    body: "DOCTHAIR vous recommande de consulter un dermatologue ou un médecin avant d'engager un protocole spécifique. Cette recommandation n'est pas un diagnostic : elle signale simplement que votre situation dépasse ce qu'une lecture cosmétique peut évaluer.",
  },
  en: {
    title: "Some of your answers deserve a healthcare professional's opinion",
    body: "DOCTHAIR recommends seeing a dermatologist or a doctor before starting any specific protocol. This is not a diagnosis: it simply signals that your situation goes beyond what a cosmetic reading can assess.",
  },
};
